/**
 * config.ts — Configuration runtime centralisée
 *
 * window.__ENV__ (défini dans /env-config.js, chargé avant le bundle) a la priorité
 * sur les valeurs baked-in à la compilation (import.meta.env.*).
 * Le client peut donc modifier env-config.js dans le package déployable sans recompiler.
 */

declare global {
  // var est requis pour la déclaration sur globalThis
  // eslint-disable-next-line no-var
  var __ENV__:
    | {
        VITE_API_BASE_URL?: string;
        VITE_MSAL_CLIENT_ID?: string;
        VITE_MSAL_AUTHORITY?: string;
        VITE_MSAL_REDIRECT_URI?: string;
        VITE_MSAL_SCOPE?: string;
        VITE_ENV?: string;
      }
    | undefined;
}

// Valeurs baked-in au moment du build (fallback si window.__ENV__ absent)
const builtEnv = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? "",
  VITE_MSAL_CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID ?? "",
  VITE_MSAL_AUTHORITY: import.meta.env.VITE_MSAL_AUTHORITY ?? "",
  VITE_MSAL_REDIRECT_URI: import.meta.env.VITE_MSAL_REDIRECT_URI ?? "",
  VITE_MSAL_SCOPE:
    (import.meta.env as Record<string, string>).VITE_MSAL_SCOPE ?? "",
  VITE_ENV: import.meta.env.VITE_ENV ?? "production",
};

function get(key: keyof typeof builtEnv): string {
  return globalThis.__ENV__?.[key] || builtEnv[key] || "";
}

export const appConfig = {
  apiBaseUrl: get("VITE_API_BASE_URL"),
  msalClientId: get("VITE_MSAL_CLIENT_ID"),
  msalAuthority: get("VITE_MSAL_AUTHORITY"),
  msalRedirectUri: get("VITE_MSAL_REDIRECT_URI"),
  msalScope: get("VITE_MSAL_SCOPE"),
  env: get("VITE_ENV") as "development" | "staging" | "production",
  /** Mode mock — uniquement pour le développement local (VITE_DEV_MOCK_AUTH=true dans .env) */
  devMockAuth: import.meta.env.VITE_DEV_MOCK_AUTH === "true",
} as const;
